import axios from 'axios'

export default {
  namespaced: true,
  state: {
    user: []
  },
  getters: {
    getUser:(state)=>state.user,
  },
  mutations: {
    setUser (state, data) {
      state.user = data
    }
  },
  actions: {
    async get({ commit }) {
      const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/profile')
      commit('setUser', response.data)
    },
    async updateInfo(context, user) {
      await axios.patch(process.env.VUE_APP_API_BASE_URL + '/user/', user)
    },
    async updateIcon(context, icon) {
      await axios.post(process.env.VUE_APP_API_BASE_URL + '/icon_upload/', icon)
    },
    async updateEmail(context, email) {
      await axios.patch(process.env.VUE_APP_API_BASE_URL + '/user_email/', email)
    },
    async updatePassword(context, password) {
      await axios.patch(process.env.VUE_APP_API_BASE_URL + '/user_password/', password)
    },
    async updateSocialAccount(context, links) {
      await axios.patch(process.env.VUE_APP_API_BASE_URL + '/social_link/', links)
    },
    async updateAppeal(context, appeals) {
      await axios.patch(process.env.VUE_APP_API_BASE_URL + '/appeal/', appeals)
    },
  }
}